<template>
  <div class="st-ppt-outer">
     <div class="footer--contenter">
        <div class="canvasfooter">
          <el-popover placement="right" width="200" v-model="shapeVisible" class="dropdown-icon">
            <div class="shape_area">
              <svg
                t="1619161258814"
                slot="reference"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6029"
                height="35px"
                width="35px"
                viewBox="0 0 1024 1024"
                :fill="currentShape == 0 ? color : 'rgb(171, 178, 218)'"
                stroke="#36425a"
                stroke-linecap="round"
                stroke-linejoin="round"
                :stroke-width="currentShape == 0 && color == '#FFFFFF' ? 30 : 0"
                @click="drawRect"
              >
                <rect x="162" y="162" height="700" width="700" />
              </svg>

              <svg
                t="1619161258814"
                slot="reference"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6029"
                height="35px"
                width="35px"
                viewBox="0 0 1024 1024"
                :fill="currentShape == 1 ? color : 'rgb(171, 178, 218)'"
                stroke="#36425a"
                stroke-linecap="round"
                stroke-linejoin="round"
                :stroke-width="currentShape == 1 && color == '#FFFFFF' ? 30 : 0"
                @click="drawCircle"
              >
                <circle cx="516" cy="516" r="350" />
              </svg>

              <svg
                t="1619161258814"
                slot="reference"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6029"
                height="35px"
                width="35px"
                viewBox="0 0 1024 1024"
                :fill="currentShape == 2 ? color : 'rgb(171, 178, 218)'"
                stroke="#36425a"
                stroke-linecap="round"
                stroke-linejoin="round"
                :stroke-width="currentShape == 2 && color == '#FFFFFF' ? 30 : 0"
                @click="drawPolygon"
              >
                <polygon
                  points="512,162 208.89,337 208.89,687 512,862 815.11,687 815.11,337 512,162"
                />
              </svg>
            </div>

            <div class="eraser" slot="reference">
              <svg
                t="1619161258814"
                slot="reference"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6029"
                width="35px"
                height="35px"
                viewBox="0 0 1024 1024"
                :fill="currentTab == 6 ? color : 'rgb(171, 178, 218)'"
                class="shape_icon"
                @click="drawShape"
                style="margin-top: -10px"
              >
                <circle
                  v-if="currentShape == '1'"
                  cx="516"
                  cy="516"
                  r="350"
                  stroke="#36425a"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  :stroke-width="
                  currentTab == 6 && currentShape == 1 && color == '#FFFFFF'
                    ? 30
                    : 0
                "
                />
                <rect
                  v-if="currentShape == '0'"
                  x="162"
                  y="162"
                  height="700"
                  width="700"
                  stroke="#36425a"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  :stroke-width="
                  currentTab == 6 && currentShape == 0 && color == '#FFFFFF'
                    ? 30
                    : 0
                "
                />
                <polygon
                  v-if="currentShape == '2'"
                  stroke="#36425a"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  :stroke-width="
                  currentTab == 6 && currentShape == 2 && color == '#FFFFFF'
                    ? 30
                    : 0
                "
                  points="512,162 208.89,337 208.89,687 512,862 815.11,687 815.11,337 512,162"
                />
              </svg>
            </div>
          </el-popover>
          <el-popover placement="right" width="300" v-model="lineVisible" >
            <draw-line-width-panel
              :color="color"
              :widthValue="widthValue"
              :tabIndex="2"
              :changeWidth="changeWidth"
            />
            <div class="eraser" @click="drawLine" slot="reference">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26.499"
                viewBox="0 0 26 26.499"
              >
                <g id="直线" transform="translate(-665 -885.502)">
                  <path
                    id="路径_609"
                    data-name="路径 609"
                    :fill="currentTab == 2 ? color : 'rgb(171, 178, 218)'"
                    d="M201.482,174.776H172.721a2.054,2.054,0,0,1,0-4.109h28.761a2.054,2.054,0,1,1,0,4.109Z"
                    transform="matrix(0.695, -0.719, 0.719, 0.695, 423.889, 913.358)"
                    stroke="#36425a"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    :stroke-width="currentTab == 2 && color == '#FFFFFF' ? 1 : 0"
                  />
                  <rect
                    id="矩形_176"
                    data-name="矩形 176"
                    fill="none"
                    width="26"
                    height="26"
                    transform="translate(665 886)"
                  />
                </g>
              </svg>
            </div>
          </el-popover>
          <el-popover placement="right" width="300" v-model="pathVisible">
            <draw-line-width-panel
              :color="color"
              :widthValue="widthValue"
              :tabIndex="1"
              :changeWidth="changeWidth"
            />
            <div class="eraser" @click="drawPath" slot="reference">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                v-if="currentTab == 1 && color == '#FFFFFF'"
              >
                <g id="组_1718" data-name="组 1718" transform="translate(10513 6077)">
                  <g id="组_1664" data-name="组 1664" transform="translate(-10512.255 -6080.5)">
                    <g
                      id="联合_18"
                      data-name="联合 18"
                      transform="translate(-10427 -6369)"
                      fill="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M 10429.158203125 6397.6201171875 C 10428.6875 6397.6201171875 10428.2724609375 6397.41796875 10428.01953125 6397.0654296875 C 10427.7353515625 6396.67041015625 10427.6787109375 6396.12744140625 10427.8623046875 6395.5732421875 L 10431.115234375 6384.23193359375 C 10431.8876953125 6381.54443359375 10434.0634765625 6379.50146484375 10436.7939453125 6378.900390625 L 10436.80078125 6378.89892578125 L 10436.80859375 6378.8974609375 L 10441.4755859375 6378.015625 C 10441.5107421875 6377.97265625 10441.546875 6377.9326171875 10441.5859375 6377.89501953125 L 10441.58984375 6377.89111328125 L 10441.5947265625 6377.88720703125 L 10445.1171875 6374.65087890625 C 10445.5712890625 6374.2314453125 10446.1650390625 6374 10446.7880859375 6374 C 10447.4775390625 6374 10448.140625 6374.2890625 10448.60546875 6374.79248046875 L 10451.0849609375 6377.48681640625 C 10452.0078125 6378.48828125 10451.9423828125 6380.0546875 10450.9404296875 6380.978515625 L 10447.4228515625 6384.21826171875 C 10447.359375 6384.27734375 10447.28515625 6384.33251953125 10447.205078125 6384.380859375 C 10446.9951171875 6384.50634765625 10446.755859375 6384.57275390625 10446.5107421875 6384.57275390625 C 10446.1357421875 6384.57275390625 10445.7734375 6384.4150390625 10445.5185546875 6384.140625 L 10444.9208984375 6383.4873046875 L 10442.4638671875 6380.82080078125 L 10437.390625 6381.7802734375 C 10435.6455078125 6382.16796875 10434.2548828125 6383.47705078125 10433.759765625 6385.19775390625 L 10431.873046875 6391.7744140625 L 10434.314453125 6389.1884765625 L 10434.7236328125 6387.6240234375 L 10434.732421875 6387.59033203125 L 10434.7451171875 6387.55859375 L 10435.01171875 6386.9169921875 C 10435.2783203125 6385.44775390625 10436.5625 6384.36279296875 10438.076171875 6384.36279296875 C 10439.7958984375 6384.36279296875 10441.1943359375 6385.76123046875 10441.1943359375 6387.48046875 C 10441.1943359375 6389.10400390625 10440.162109375 6390.3828125 10438.68359375 6390.5908203125 L 10438.6494140625 6390.595703125 L 10438.6142578125 6390.595703125 L 10438.4755859375 6390.595703125 C 10438.2705078125 6390.59765625 10437.1611328125 6390.833984375 10436.1943359375 6391.0634765625 L 10433.5966796875 6393.5830078125 L 10440.0517578125 6391.67529296875 L 10440.0673828125 6391.6708984375 L 10440.08203125 6391.66748046875 C 10442.0126953125 6391.22802734375 10442.890625 6390.47412109375 10443.322265625 6388.8857421875 L 10443.8505859375 6386.796875 C 10444.0068359375 6386.17333984375 10444.56640625 6385.7373046875 10445.208984375 6385.7373046875 C 10445.3037109375 6385.7373046875 10445.3994140625 6385.7470703125 10445.4921875 6385.76611328125 C 10445.873046875 6385.84716796875 10446.193359375 6386.0712890625 10446.3974609375 6386.39697265625 C 10446.6015625 6386.7216796875 10446.662109375 6387.1064453125 10446.5703125 6387.4794921875 L 10446 6389.72314453125 L 10445.9990234375 6389.7265625 L 10445.998046875 6389.73046875 C 10445.3173828125 6392.25537109375 10443.830078125 6393.5625 10440.865234375 6394.23876953125 L 10429.7412109375 6397.52783203125 C 10429.54296875 6397.5888671875 10429.3466796875 6397.6201171875 10429.158203125 6397.6201171875 Z"
                        stroke="none"
                      />
                      <path
                        d="M 10429.158203125 6397.1201171875 C 10429.29296875 6397.1201171875 10429.4404296875 6397.09765625 10429.5966796875 6397.04931640625 L 10440.7392578125 6393.7548828125 C 10443.3046875 6393.17236328125 10444.8310546875 6392.13916015625 10445.515625 6389.60009765625 L 10446.0849609375 6387.35986328125 C 10446.2080078125 6386.861328125 10445.8955078125 6386.36328125 10445.3916015625 6386.255859375 C 10444.919921875 6386.15869140625 10444.453125 6386.44970703125 10444.3349609375 6386.91943359375 L 10443.8056640625 6389.01220703125 C 10443.2861328125 6390.9326171875 10442.1318359375 6391.7138671875 10440.193359375 6392.15478515625 L 10431.9677734375 6394.5859375 L 10431.765625 6394.64892578125 C 10431.7548828125 6394.65283203125 10431.7451171875 6394.65625 10431.734375 6394.65966796875 C 10431.7451171875 6394.6552734375 10431.7548828125 6394.65087890625 10431.765625 6394.646484375 L 10431.94140625 6394.49169921875 L 10435.94140625 6390.6123046875 L 10434.7666015625 6389.4375 L 10431.107421875 6393.31396484375 L 10430.8173828125 6393.6376953125 L 10430.9189453125 6393.28759765625 L 10433.279296875 6385.0595703125 C 10433.8251953125 6383.16064453125 10435.3642578125 6381.71533203125 10437.2900390625 6381.29052734375 L 10442.6435546875 6380.27783203125 L 10445.2900390625 6383.14990234375 L 10445.884765625 6383.80029296875 C 10446.1640625 6384.10009765625 10446.611328125 6384.154296875 10446.947265625 6383.95263671875 C 10446.9951171875 6383.923828125 10447.0419921875 6383.8896484375 10447.083984375 6383.8505859375 L 10450.6015625 6380.61083984375 C 10451.3984375 6379.87646484375 10451.451171875 6378.62255859375 10450.716796875 6377.8251953125 L 10448.23828125 6375.1318359375 C 10447.5048828125 6374.33740234375 10446.2529296875 6374.28466796875 10445.455078125 6375.01904296875 L 10441.9326171875 6378.25537109375 C 10441.8671875 6378.318359375 10441.814453125 6378.39208984375 10441.7724609375 6378.46826171875 C 10441.7021484375 6378.5947265625 10441.6650390625 6378.73583984375 10441.6640625 6378.87744140625 C 10441.6650390625 6378.73583984375 10441.7021484375 6378.5947265625 10441.7724609375 6378.46826171875 L 10436.9013671875 6379.388671875 C 10434.3515625 6379.9501953125 10432.31640625 6381.8623046875 10431.595703125 6384.36962890625 L 10428.33984375 6395.7216796875 C 10428.076171875 6396.50341796875 10428.455078125 6397.1201171875 10429.158203125 6397.1201171875 M 10435.94140625 6390.60986328125 C 10435.94140625 6390.60986328125 10438.08203125 6390.095703125 10438.4755859375 6390.095703125 L 10438.6142578125 6390.095703125 C 10439.880859375 6389.91748046875 10440.6943359375 6388.7998046875 10440.6943359375 6387.48046875 C 10440.6943359375 6386.03515625 10439.521484375 6384.86279296875 10438.076171875 6384.86279296875 C 10436.736328125 6384.86279296875 10435.6318359375 6385.8701171875 10435.4794921875 6387.1708984375 L 10435.4794921875 6387.09521484375 L 10435.20703125 6387.75048828125 L 10434.7666015625 6389.4345703125 L 10435.94140625 6390.60986328125 M 10429.158203125 6398.1201171875 C 10428.5244140625 6398.1201171875 10427.9619140625 6397.841796875 10427.61328125 6397.35693359375 C 10427.2373046875 6396.8330078125 10427.154296875 6396.130859375 10427.3837890625 6395.42626953125 L 10430.634765625 6384.09375 C 10431.4580078125 6381.22998046875 10433.7763671875 6379.052734375 10436.6865234375 6378.412109375 C 10436.6962890625 6378.41015625 10436.7060546875 6378.40771484375 10436.7158203125 6378.40625 L 10441.21875 6377.55517578125 C 10441.2255859375 6377.54833984375 10441.232421875 6377.54150390625 10441.2392578125 6377.53515625 C 10441.2451171875 6377.52978515625 10441.25 6377.5244140625 10441.255859375 6377.51904296875 L 10444.7783203125 6374.28271484375 C 10445.3251953125 6373.7783203125 10446.0390625 6373.5 10446.7880859375 6373.5 C 10447.6171875 6373.5 10448.4130859375 6373.84765625 10448.97265625 6374.453125 L 10451.453125 6377.14794921875 C 10452.5615234375 6378.3525390625 10452.484375 6380.23583984375 10451.279296875 6381.34619140625 L 10447.76171875 6384.5859375 C 10447.6748046875 6384.6669921875 10447.5732421875 6384.7431640625 10447.462890625 6384.8095703125 C 10447.1748046875 6384.98193359375 10446.845703125 6385.07275390625 10446.5107421875 6385.07275390625 C 10445.9970703125 6385.07275390625 10445.501953125 6384.85693359375 10445.15234375 6384.4814453125 C 10445.150390625 6384.47900390625 10445.1484375 6384.47705078125 10445.146484375 6384.47509765625 L 10444.5517578125 6383.82470703125 L 10442.2841796875 6381.36376953125 L 10437.4912109375 6382.27001953125 C 10435.9287109375 6382.6201171875 10434.68359375 6383.7939453125 10434.240234375 6385.3359375 L 10432.9208984375 6389.93603515625 L 10433.8623046875 6388.93798828125 L 10434.2392578125 6387.49755859375 C 10434.2509765625 6387.45263671875 10434.265625 6387.4091796875 10434.283203125 6387.36669921875 L 10434.5302734375 6386.77294921875 C 10434.861328125 6385.09521484375 10436.3388671875 6383.86279296875 10438.076171875 6383.86279296875 C 10440.0712890625 6383.86279296875 10441.6943359375 6385.48583984375 10441.6943359375 6387.48046875 C 10441.6943359375 6388.35009765625 10441.4189453125 6389.18408203125 10440.919921875 6389.82861328125 C 10440.384765625 6390.51806640625 10439.6162109375 6390.96435546875 10438.75390625 6391.0859375 C 10438.70703125 6391.09228515625 10438.6611328125 6391.095703125 10438.6142578125 6391.095703125 L 10438.4892578125 6391.095703125 C 10438.2607421875 6391.11279296875 10437.3046875 6391.31640625 10436.443359375 6391.5185546875 L 10435.40234375 6392.52783203125 L 10439.91015625 6391.19580078125 C 10439.9306640625 6391.18994140625 10439.951171875 6391.1845703125 10439.9716796875 6391.1796875 C 10441.73046875 6390.77978515625 10442.455078125 6390.16845703125 10442.837890625 6388.7587890625 L 10443.365234375 6386.67431640625 C 10443.578125 6385.82861328125 10444.3359375 6385.2373046875 10445.208984375 6385.2373046875 C 10445.337890625 6385.2373046875 10445.466796875 6385.25048828125 10445.59375 6385.2763671875 C 10445.595703125 6385.27685546875 10445.59765625 6385.27734375 10445.599609375 6385.27783203125 C 10446.111328125 6385.38671875 10446.544921875 6385.68994140625 10446.8212890625 6386.13134765625 C 10447.09765625 6386.572265625 10447.1806640625 6387.09375 10447.0556640625 6387.599609375 C 10447.0556640625 6387.6015625 10447.0546875 6387.60400390625 10447.0537109375 6387.60595703125 L 10446.484375 6389.84619140625 C 10446.4833984375 6389.85107421875 10446.482421875 6389.85595703125 10446.4814453125 6389.8603515625 C 10446.0927734375 6391.30126953125 10445.4345703125 6392.38818359375 10444.46875 6393.18310546875 C 10443.615234375 6393.88525390625 10442.5107421875 6394.375 10440.9921875 6394.72265625 L 10429.8857421875 6398.00634765625 C 10429.640625 6398.08203125 10429.3955078125 6398.1201171875 10429.158203125 6398.1201171875 Z"
                        stroke="none"
                        fill="#36425a"
                      />
                    </g>
                  </g>
                  <rect
                    id="矩形_262"
                    data-name="矩形 262"
                    width="26"
                    height="26"
                    transform="translate(-10513 -6077)"
                    fill="none"
                  />
                </g>
              </svg>

              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
              >
                <g id="钢笔" transform="translate(10333 6109)">
                  <g id="组_1664" data-name="组 1664" transform="translate(-10332.255 -6112.5)">
                    <path
                      id="路径_747"
                      data-name="路径 747"
                      :fill="currentTab == 1 ? color : 'rgb(171, 178, 218)'"
                      d="M297.327,469.917a2.616,2.616,0,0,0-5.213-.31l0,0s-.31,1.955-.711,2.267l1.176,1.176s2.141-.516,2.534-.514l-.029-.029a2.615,2.615,0,0,0,2.246-2.587Zm-1.773.135a.818.818,0,0,1-.781.7l0,0c-.121,0-1.019,0-1.019,0,.038-.1.13-.649.173-.9a.129.129,0,0,1,0-.029c0-.016.009-.031.011-.047,0-.031.009-.049.009-.049l0,0a.817.817,0,0,1,1.6.319Z"
                      transform="translate(-283.634 -451.437)"
                    />
                    <path
                      id="路径_748"
                      data-name="路径 748"
                      :fill="currentTab == 1 ? color : 'rgb(171, 178, 218)'"
                      d="M110.05,676.309l.175-.155,4-3.878-1.176-1.176-3.658,3.878-.294.328C108.7,676,109.173,676.695,110.05,676.309Z"
                      transform="translate(-105.284 -650.663)"
                    />
                    <path
                      id="路径_749"
                      data-name="路径 749"
                      :fill="currentTab == 1 ? color : 'rgb(171, 178, 218)'"
                      d="M18.393,190.089a.9.9,0,0,0-1.057.662l-.53,2.094c-.518,1.921-1.674,2.7-3.613,3.142L4.968,198.42l-.2.061c-.891.316-1.187-.3-.949-1.005l.1-.355,2.361-8.229a5.376,5.376,0,0,1,4.013-3.768l5.352-1.012-.759-.824a.85.85,0,0,1-.112-.987l-4.872.922A7.109,7.109,0,0,0,4.6,188.2L1.339,199.553c-.314.931.285,1.629,1.257,1.329l11.142-3.294c2.565-.583,4.093-1.616,4.778-4.156l.568-2.24A.9.9,0,0,0,18.393,190.089Z"
                      transform="translate(0 -172.833)"
                    />
                    <path
                      id="路径_750"
                      data-name="路径 750"
                      :fill="currentTab == 1 ? color : 'rgb(171, 178, 218)'"
                      d="M607.826,8.826l-2.48-2.693a1.975,1.975,0,0,0-2.783-.114l-3.521,3.238a.864.864,0,0,0-.049,1.2l.759.824,2.646,2.873.6.649a.852.852,0,0,0,1.061.153.979.979,0,0,0,.137-.1l3.517-3.241a1.976,1.976,0,0,0,.117-2.785Z"
                      transform="translate(-584.108 0)"
                    />
                  </g>
                </g>
              </svg>
            </div>
          </el-popover>
          <el-popover placement="right" width="300" v-model="markVisible">
            <draw-line-width-panel
              :color="color"
              :widthValue="widthValue"
              :tabIndex="5"
              :changeWidth="changeWidth"
            />
            <div class="eraser" @click="drawMark" slot="reference">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26.454"
                height="24.667"
                viewBox="0 0 26.454 24.667"
              >
                <path
                  id="画笔"
                  :fill="currentTab == 5 ? color : 'rgb(171, 178, 218)'"
                  stroke="#36425a"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  :stroke-width="currentTab == 5 && color == '#FFFFFF' ? 1 : 0"
                  d="M18.749,34.734l7.323,7.323a1.29,1.29,0,0,1,0,1.831L16,53.958l-2.768.915L11.4,56.7a1.29,1.29,0,0,1-1.831,0L4.059,51.189a1.29,1.29,0,0,1,0-1.831L5.89,47.528,6.8,44.782l10.07-10.07a1.29,1.29,0,0,1,1.831,0Zm.915,4.577L11.426,47.55l1.809,1.831,8.283-8.217-1.831-1.853Zm-16,14.194,3.662,3.662L5.515,59,0,57.167l3.662-3.662Z"
                  transform="translate(0 -34.331)"
                />
              </svg>
            </div>
          </el-popover>
          <el-popover placement="right" width="300" v-model="easreVisible">
            <draw-line-width-panel
              :color="color"
              :widthValue="widthValue"
              :tabIndex="3"
              :changeWidth="changeWidth"
            />

            <div class="eraser" @click="earse" slot="reference">
              <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              v-if="currentTab == 3 && color == '#FFFFFF'"
            >
              <g id="橡皮擦" transform="translate(-797 -882)">
                <g
                  id="组_1162"
                  data-name="组 1162"
                  transform="translate(20 -1)"
                >
                  <path
                    id="联合_19"
                    data-name="联合 19"
                    d="M11113.742,6971.061l-7.123-6.72a2.524,2.524,0,0,0-3.556.087l-11.343,11.915a2.521,2.521,0,0,0,0,3.529l4.083,4.085a3.78,3.78,0,0,0,2.671,1.109h13.615a1.26,1.26,0,0,0,0-2.521h-6.3l7.98-7.84.076-.077,0,0A2.523,2.523,0,0,0,11113.742,6971.061Zm-10.816,10.715a2.512,2.512,0,0,1-1.766.717h-2.672a1.255,1.255,0,0,1-.895-.365l-4.083-4.083,2.937-3.013,6.63,6.643Z"
                    transform="translate(-10313 -6078.65)"
                    fill="#fff"
                    stroke="#36425a"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                  />
                </g>
                <rect
                  id="矩形_174"
                  data-name="矩形 174"
                  width="26"
                  height="26"
                  transform="translate(797 882)"
                  fill="none"
                />
              </g>
              </svg>-->

              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                <g id="橡皮擦" transform="translate(-797 -882)">
                  <g id="组_1162" data-name="组 1162" transform="translate(20 -1)">
                    <path
                      id="路径_606"
                      data-name="路径 606"
                      fill="rgb(255, 255, 255)"
                      d="M-10033.332-6461.843l-4.425,3.772,5.368,5.948h4.643l1.958-1.813Z"
                      transform="translate(10817 7357)"
                    />
                    <path
                      id="路径_604"
                      data-name="路径 604"
                      :fill="currentTab == 3 ? 'red' : 'rgb(171, 178, 218)'"
                      d="M95.317,109.056l-7.122-6.72a2.524,2.524,0,0,0-3.556.087L73.3,114.338a2.521,2.521,0,0,0,0,3.529l4.083,4.085a3.78,3.78,0,0,0,2.672,1.109H93.665a1.26,1.26,0,1,0,0-2.521h-6.3l7.98-7.84.077-.077,0,0A2.523,2.523,0,0,0,95.317,109.056ZM84.5,119.771a2.512,2.512,0,0,1-1.766.718H80.063a1.257,1.257,0,0,1-.895-.365l-4.083-4.083,2.936-3.013,6.63,6.643-.151.1Z"
                      transform="translate(705.425 783.354)"
                    />
                  </g>
                </g>
              </svg>
            </div>
          </el-popover>

          <el-popover placement="right" width="300" v-model="fontVisible">
            <div v-for="(item, index) in fontFamilies" :key="index">
              <div class="text_area" @click="changeTextFont(index)">
                <p
                  :class="`${(color == '#FFFFFF' && currentFont == index) ?'white-text-font':'text-font'}`"
                  :style="`color:${
                  currentFont == index ? color : 'rgb(171, 178, 218)'
                }; font-family:${item} ;`"
                >{{item}}</p>
              </div>
            </div>
            <div class="eraser" @click="edit" slot="reference">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="23.417"
                viewBox="0 0 26 23.417"
                style="cursor: pointer"
                v-if="currentTab == 4 && color == '#FFFFFF'"
              >
                <g id="文本" transform="translate(-837.159 -813)">
                  <g
                    id="路径_602"
                    data-name="路径 602"
                    transform="translate(836.171 813.756)"
                    fill="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M 10.59291458129883 21.97989082336426 L 9.385805130004883 21.97989082336426 L 9.634719848632813 21.73097991943359 C 9.024940490722656 21.39247512817383 8.611414909362793 20.74181365966797 8.611414909362793 19.9963321685791 L 8.611414909362793 3.213171243667603 L 3.18745493888855 3.213171243667603 L 3.180254936218262 3.213171243667603 L 3.173054933547974 3.212961435317993 C 2.228115081787109 3.185751438140869 1.487905025482178 2.423911333084106 1.487905025482178 1.478581309318542 C 1.487905025482178 0.5332513451576233 2.228115081787109 -0.228588655591011 3.173054933547974 -0.2557986676692963 L 3.180254936218262 -0.25600865483284 L 3.18745493888855 -0.25600865483284 L 18.04336547851563 -0.25600865483284 C 19.02265548706055 -0.25600865483284 19.81936454772949 0.5407013297080994 19.81936454772949 1.519991278648376 C 19.81936454772949 2.499281406402588 19.02265548706055 3.29599142074585 18.04336547851563 3.29599142074585 L 12.5754451751709 3.29599142074585 L 12.5754451751709 19.99838066101074 C 12.5754451751709 21.09099197387695 11.68608474731445 21.97989082336426 10.59291458129883 21.97989082336426 Z"
                      stroke="none"
                    />
                    <path
                      d="M 10.59291458129883 21.47989082336426 C 11.41188526153564 21.47989082336426 12.0754451751709 20.81633186340332 12.0754451751709 19.99838066101074 L 12.0754451751709 2.79599142074585 L 18.04336547851563 2.79599142074585 C 18.74807548522949 2.79599142074585 19.31936454772949 2.224701404571533 19.31936454772949 1.519991278648376 C 19.31936454772949 0.8152813315391541 18.74807548522949 0.2439913302659988 18.04336547851563 0.2439913302659988 L 3.18745493888855 0.2439913302659988 C 2.519454956054688 0.2632313370704651 1.987905025482178 0.8103013634681702 1.987905025482178 1.478581309318542 C 1.987905025482178 2.14686131477356 2.519454956054688 2.693931341171265 3.18745493888855 2.713171243667603 L 9.111414909362793 2.713171243667603 L 9.111414909362793 19.9963321685791 C 9.111414909362793 20.8153018951416 9.775995254516602 21.47886085510254 10.59394454956055 21.47886085510254 L 10.59291458129883 21.47989082336426 M 10.59291458129883 22.47989082336426 C 10.57301807403564 22.47989082336426 10.55325126647949 22.47930335998535 10.53356647491455 22.4781379699707 C 9.192527770996094 22.44590950012207 8.111414909362793 21.3449821472168 8.111414909362793 19.9963321685791 L 8.111414909362793 3.713171243667603 L 3.18745493888855 3.713171243667603 C 3.177855014801025 3.713171243667603 3.168255090713501 3.71303129196167 3.15866494178772 3.712761402130127 C 1.941415071487427 3.677701234817505 0.9879050254821777 2.696331262588501 0.9879050254821777 1.478581309318542 C 0.9879050254821777 0.2608313262462616 1.941415071487427 -0.7205386757850647 3.15866494178772 -0.7555986642837524 C 3.168255090713501 -0.755868673324585 3.177855014801025 -0.7560086846351624 3.18745493888855 -0.7560086846351624 L 18.04336547851563 -0.7560086846351624 C 19.29835510253906 -0.7560086846351624 20.31936454772949 0.2650013267993927 20.31936454772949 1.519991278648376 C 20.31936454772949 2.774981260299683 19.29835510253906 3.79599142074585 18.04336547851563 3.79599142074585 L 13.0754451751709 3.79599142074585 L 13.0754451751709 19.99838066101074 C 13.0754451751709 21.36669158935547 11.96178531646729 22.47989082336426 10.59291458129883 22.47989082336426 Z"
                      stroke="none"
                      fill="#36425a"
                    />
                  </g>
                  <g
                    id="路径_605"
                    data-name="路径 605"
                    transform="translate(836.171 813.937)"
                    fill="#fff"
                    stroke-linecap="round"
                  >
                    <path
                      d="M 14.76382350921631 21.97988510131836 L 14.13258266448975 21.97988510131836 L 14.13216304779053 21.47988510131836 L 14.13218307495117 21.97988510131836 C 13.67043304443359 21.97990417480469 13.24192333221436 21.75047492980957 12.98592281341553 21.36615371704102 C 12.7297830581665 20.98162460327148 12.68327331542969 20.49757385253906 12.86152267456055 20.07131385803223 L 17.6903133392334 8.499764442443848 C 17.92756271362305 7.931044578552246 18.47909355163574 7.563534736633301 19.09538269042969 7.563534736633301 L 19.80910301208496 7.563534736633301 C 20.40857315063477 7.563534736633301 20.95389366149902 7.916714668273926 21.1988525390625 8.463294982910156 L 26.36525344848633 19.99847412109375 C 26.56082344055176 20.43590545654297 26.52195358276367 20.93673515319824 26.26141357421875 21.3384838104248 C 26.00096321105957 21.74010467529297 25.5596923828125 21.9798755645752 25.08101272583008 21.9798755645752 L 24.36915397644043 21.9798755645752 C 23.7475528717041 21.9798755645752 23.19417381286621 21.60806465148926 22.95937347412109 21.03264427185059 L 21.69998168945313 17.9463939666748 L 17.43250274658203 17.9463939666748 L 16.17205238342285 21.0329647064209 C 15.93740272521973 21.60768508911133 15.38463306427002 21.97939491271973 14.76382350921631 21.97988510131836 Z M 18.24613380432129 15.21847438812256 L 20.64927673339844 15.21847438812256 L 19.47311019897461 12.15104103088379 L 18.24613380432129 15.21847438812256 Z"
                      stroke="none"
                    />
                    <path
                      d="M 14.13216304779053 21.47988510131836 C 14.13228893280029 21.47988510131836 14.1324577331543 21.47988510131836 14.13258266448975 21.47988510131836 L 14.76342296600342 21.47988510131836 C 15.17853260040283 21.47955513000488 15.55225276947021 21.2282543182373 15.70916271209717 20.84393501281738 L 17.09660339355469 17.4463939666748 L 22.03597259521484 17.44638442993164 L 23.42231369018555 20.84373474121094 C 23.57929229736328 21.22843551635742 23.95346260070801 21.4798755645752 24.36915397644043 21.4798755645752 L 25.08077239990234 21.4798755645752 C 25.38854026794434 21.47882843017578 25.67465019226074 21.3243350982666 25.84190368652344 21.06643486022949 C 26.00915336608887 20.80853462219238 26.03439331054688 20.48347473144531 25.90893363952637 20.20285415649414 L 20.74258232116699 8.667784690856934 C 20.57774353027344 8.299975395202637 20.21290397644043 8.062656402587891 19.80910301208496 8.063534736633301 L 19.0954532623291 8.063534736633301 C 19.09542846679688 8.063534736633301 19.09540367126465 8.063534736633301 19.09537887573242 8.063534736633301 C 18.68277740478516 8.063534736633301 18.31060409545898 8.311528205871582 18.15174293518066 8.692324638366699 L 13.32281303405762 20.26421546936035 C 13.20955276489258 20.53506469726563 13.23929309844971 20.84462547302246 13.4020528793335 21.08896446228027 C 13.56473350524902 21.33319091796875 13.83871555328369 21.47989845275879 14.13216304779053 21.47988510131836 M 19.48295211791992 10.7801342010498 L 21.37649345397949 15.71847438812256 L 17.50761222839355 15.71847438812256 L 19.48295211791992 10.7801342010498 M 14.7642126083374 22.47988510131836 L 14.13258266448975 22.47988510131836 C 13.50279331207275 22.47990417480469 12.9187126159668 22.16717529296875 12.56978321075439 21.64333534240723 C 12.22066307067871 21.11921501159668 12.1572732925415 20.45943450927734 12.40022277832031 19.87842559814453 L 17.22887229919434 8.307214736938477 C 17.54403305053711 7.55174446105957 18.27670288085938 7.063534736633301 19.09538269042969 7.063534736633301 L 19.80910301208496 7.063534736633301 C 20.60530281066895 7.063534736633301 21.3297233581543 7.53271484375 21.65513229370117 8.258814811706543 L 26.82157325744629 19.79409408569336 C 27.08673286437988 20.3871955871582 27.03405380249023 21.06600379943848 26.68092346191406 21.61054420471191 C 26.32790374755859 22.15489387512207 25.72980308532715 22.4798755645752 25.08101272583008 22.4798755645752 L 24.36915397644043 22.4798755645752 C 23.54344367980957 22.4798755645752 22.80835342407227 21.98595428466797 22.49643325805664 21.22154426574707 L 21.36398696899414 18.4463939666748 L 17.76840400695801 18.4463939666748 L 16.63494300842285 21.22199440002441 C 16.3232421875 21.98545455932617 15.58892345428467 22.47922515869141 14.7642126083374 22.47988510131836 Z M 18.98464965820313 14.71847438812256 L 19.92206764221191 14.71847438812256 L 19.46327018737793 13.52192878723145 L 18.98464965820313 14.71847438812256 Z"
                      stroke="none"
                      fill="#36425a"
                    />
                  </g>
                </g>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="21.417"
                viewBox="0 0 24 21.417"
                style="cursor: pointer"
                v-else
              >
                <g id="文本" transform="translate(-838.159 -814)">
                  <path
                    id="路径_602"
                    data-name="路径 602"
                    :fill="currentTab == 4 ? color : 'rgb(171, 178, 218)'"
                    d="M10.594,21.479A1.483,1.483,0,0,1,9.111,20V2.713H3.187a1.235,1.235,0,0,1,0-2.469H18.043a1.276,1.276,0,1,1,0,2.552H12.075V20a1.482,1.482,0,0,1-1.483,1.482Z"
                    transform="translate(836.171 813.756)"
                  />
                  <path
                    id="路径_605"
                    data-name="路径 605"
                    :fill="currentTab == 4 ? color : 'rgb(171, 178, 218)'"
                    d="M22.035,17.446H17.1l-1.387,3.4a1.022,1.022,0,0,1-.946.636h-.631a.877.877,0,0,1-.81-1.216L18.152,8.692a1.022,1.022,0,0,1,.944-.629h.714a1.022,1.022,0,0,1,.933.6L25.909,20.2a.907.907,0,0,1-.828,1.277h-.712a1.023,1.023,0,0,1-.947-.636l-1.386-3.4ZM19.483,10.78l-1.975,4.938h3.869L19.483,10.78Z"
                    transform="translate(836.171 813.937)"
                  />
                </g>
              </svg>
            </div>
          </el-popover>

          <el-popover placement="right" width="100px" v-model="colorVisible">
            <div class="colorList">
              <div
                style="width: 40px; height: 40px;margin: 5px; display: flex;"
                v-for="item in colors"
                :key="item"
              >
                <div
                  @click="changeColor(item)"
                  :style="`background-color: ${item};border: ${
                  item == '#FFFFFF' ? '1px' : '0px'
                } solid #36425a`"
                  class="colors"
                >
                  <div
                    v-if="color == item"
                    style="
                    width: 12px;
                    height: 12px;
                    background: #15c39a;
                    border: 2px solid #ffffff;
                    border-radius: 50%;
                    opacity: 1;
                    margin-top: 18px;
                    margin-left: 18px;
                  "
                  ></div>
                </div>
              </div>
            </div>
            <!-- :class="currentOnColorFlag ? '' : 'cls-1-color-flag-gray'" -->
            <div
              class="eraser"
              slot="reference"
              @mouseenter="mouseOnColorFlag(true)"
              @mouseleave="mouseOnColorFlag(false)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25.842"
                height="27.234"
                viewBox="0 0 27.842 29.234"
                :style="`fill:${color};stroke-linecap: round;stroke-linejoin: round;cursor: pointer;stroke: ${
                color == '#FFFFFF' ? '#36425a' : '#FFFFFF00'
              };`"
              >
                <path
                  id="颜料填充白色"
                  d="M78.564,50.663a.4.4,0,0,0-.674,0c-.707,1.161-2.278,3.864-2.278,4.981a2.615,2.615,0,0,0,5.23,0C80.842,54.527,79.271,51.821,78.564,50.663ZM77.6,45.427,66.553,34.378a.9.9,0,0,1-.211-.211l-3.884-3.884a.879.879,0,0,0-1.243,1.243L64.689,35,54.258,45.427a.878.878,0,0,0,0,1.243L65.307,57.719a.878.878,0,0,0,1.243,0L77.6,46.67A.877.877,0,0,0,77.6,45.427ZM65.929,36.242l9.806,9.806H56.123l9.806-9.806Z"
                  transform="translate(-53.5 -29.525)"
                />
              </svg>

              <!-- <svg


              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              class="color_flag"
              style="cursor: pointer"
            >
              <g id="吸管" transform="translate(9316 6241)">
                <path
                  id="路径_603"
                  data-name="路径 603"
                  class="color-1-svg"
                  d="M-9314.008-6219.452s-.334,1.841,1.9,1.562c.893-.781,2.214-2.137,2.558-2.309a4.6,4.6,0,0,0,2.619-.944,72.537,72.537,0,0,0,5.415-6.313s-3.334,1.651-5.415,1.717a7.235,7.235,0,0,0-4.207,1.42C-9311.87-6223.762-9314.008-6219.452-9314.008-6219.452Z"
                />
                <path
                  id="路径_600"
                  data-name="路径 600"
                  class="color-2-svg"
                  d="M22.68,1.411a4.816,4.816,0,0,0-6.812,0L11.951,5.327l-1.62-1.62a.851.851,0,0,0-.615-.257A.875.875,0,0,0,9.1,4.943l2.236,2.233.21.2L3.069,15.866a3.634,3.634,0,0,0-1.035,3.158L.7,20.361a2.156,2.156,0,0,0,0,3.016A2.138,2.138,0,0,0,2.214,24a2.077,2.077,0,0,0,1.5-.626l1.335-1.328a3.526,3.526,0,0,0,.6.053A3.672,3.672,0,0,0,8.23,21.032l8.477-8.486.2.2s.015,0,.015.009l2.221,2.23a.878.878,0,0,0,1.245-1.238l-1.62-1.62L22.68,8.215a4.825,4.825,0,0,0,0-6.8ZM6.985,19.8a1.9,1.9,0,0,1-1.846.486.867.867,0,0,0-.885.1l-.09.074-1.68,1.686a.38.38,0,0,1-.27.111.4.4,0,0,1-.36-.237.392.392,0,0,1,.09-.417l1.62-1.631a.983.983,0,0,0,.15-.173.45.45,0,0,0,.075-.132.914.914,0,0,0,.06-.141,1.1,1.1,0,0,0,.03-.15.953.953,0,0,0-.06-.41,1.862,1.862,0,0,1,.48-1.861l8.477-8.485,2.686,2.692Z"
                  transform="translate(-9315.083 -6241)"
                />
              </g>
              </svg>-->
            </div>
          </el-popover>

          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="2" viewBox="0 0 30 2">
            <line
              id="分割线"
              transform="translate(0.5)"
              fill="none"
              stroke="#707070"
              stroke-dasharray="2"
              x2="30"
            />
          </svg>

          <div class="do_btn">
            <el-tooltip content="undo" placement="top">
              <div class="eraser" @click="undo">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                  <g id="撤销1" transform="translate(-933 -883)">
                    <path
                      id="路径_592"
                      data-name="路径 592"
                      :fill="
                      draw && draw.canUndo() ? '#36425a' : 'rgb(171, 178, 218)'
                    "
                      d="M107.021,26.251a6.312,6.312,0,0,0,2.965-7.38,5.277,5.277,0,0,0-4.127-3.78,12.979,12.979,0,0,0-2.965-.35c-.35,0-.466.059-.466.466v3.9c-.291-.059-.35-.231-.466-.35-2.209-2.206-4.362-4.359-6.511-6.567-.116-.116-.406-.291-.116-.581,2.325-2.325,4.708-4.652,7.092-7.036V7.593c0,.466.059.64.64.64a14.523,14.523,0,0,1,5.408,1.106,8.093,8.093,0,0,1,5.058,7.617,9.293,9.293,0,0,1-5.874,9.239c-.059,0-.116.059-.231.059-.294.113-.409.172-.409,0Zm0,0"
                      transform="translate(841.789 880.432)"
                    />
                  </g>
                </svg>
              </div>
            </el-tooltip>
            <el-tooltip content="redo" placement="top">
              <div class="eraser" @click="redo">
                <svg
                  id="撤销2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                >
                  <path
                    id="路径_592"
                    data-name="路径 592"
                    :fill="
                    draw && draw.canRedo() ? '#36425a' : 'rgb(171, 178, 218)'
                  "
                    d="M101.74,26.251a6.312,6.312,0,0,1-2.965-7.38,5.277,5.277,0,0,1,4.127-3.78,12.979,12.979,0,0,1,2.965-.35c.35,0,.466.059.466.466v3.9c.291-.059.35-.231.466-.35,2.209-2.206,4.362-4.359,6.511-6.567.116-.116.406-.291.116-.581-2.325-2.325-4.708-4.652-7.092-7.036V7.593c0,.466-.059.64-.64.64a14.523,14.523,0,0,0-5.408,1.106,8.093,8.093,0,0,0-5.058,7.617A9.293,9.293,0,0,0,101.1,26.2c.059,0,.116.059.231.059.294.113.409.172.409,0Zm0,0"
                    transform="translate(-91.55 -2.568)"
                  />
                </svg>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip content="clear" placement="top">
            <div class="eraser" @click="clear">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                class="cls-1-delete"
              >
                <g id="删除" transform="translate(-1090 -880)">
                  <g id="组_631" data-name="组 631" transform="translate(1040.632 859.391)">
                    <path
                      id="路径_433"
                      data-name="路径 433"
                      class="color-1-svg"
                      d="M62.54,21.609a4.441,4.441,0,0,0-4.437,4.3H52.5a1.132,1.132,0,0,0,0,2.264h1.249V40.832c0,2.377,1.611,4.32,3.6,4.32H67.5c1.988,0,3.6-1.932,3.6-4.32V28.178h1.132a1.132,1.132,0,0,0,0-2.264H66.969a4.428,4.428,0,0,0-4.429-4.3Zm-2.317,4.3a2.319,2.319,0,0,1,4.629,0ZM57.348,43.036c-.706,0-1.483-.906-1.483-2.2V28.178H68.98V40.843c0,1.294-.777,2.2-1.483,2.2H57.348Zm0,0"
                      transform="translate(0 0)"
                    />
                    <path
                      id="路径_434"
                      data-name="路径 434"
                      class="color-1-svg"
                      d="M325.931,436.017a1.032,1.032,0,0,0,.908-1.122v-6.4a.929.929,0,1,0-1.816,0v6.4A1.027,1.027,0,0,0,325.931,436.017Zm3.287,0a1.032,1.032,0,0,0,.908-1.122v-6.4a.929.929,0,1,0-1.816,0v6.4A1.034,1.034,0,0,0,329.218,436.017Zm3.458,0a1.032,1.032,0,0,0,.908-1.122v-6.4a.929.929,0,1,0-1.816,0v6.4A1.024,1.024,0,0,0,332.676,436.017Zm0,0"
                      transform="translate(-266.932 -395.813)"
                    />
                  </g>
                </g>
              </svg>
            </div>
          </el-tooltip>
        </div>
      </div>
    <div id="canvasouter" class="ppt-out-line">
      <div  id="canvasbox">
        <div>
        <canvas id="canvas" :style="`background-image:url(${Fn.hashToUrl(getPage.pic || getPage.url)})`"></canvas>
        <canvas id="textCanvas"></canvas>
        </div>
      </div>

      <!-- 颜色，多边形图形，直线，画笔，荧光笔，text box, 橡皮，朝左undo朝右恢复（参考classdojo), 清除键。 -->
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Draw, { DrawTypeData } from "@/utils/draw";
import colorSelector from "@/utils/color";
import drawLineWidthPanel from "./drawLineWidthPanel.vue";
import colorPanel from "./colorPanel.vue";

export default {
  components: { drawLineWidthPanel, colorPanel },
  computed: {
    ...mapGetters(['getPage', 'getQuestion']),
    ...mapGetters('student', ['myPageAnswerList'])
  },
  props: {
    sendCanvas: { type: Function },
    sendDrawText: { type: Function },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    slide_id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      processi: 0,
      base64Str: '',
      one: { content: '' },
      shapeVisible: false,
      lineVisible: false,
      pathVisible: false,
      markVisible: false,
      easreVisible: false,
      fontVisible: false,
      colorVisible: false,
      draw: null,
      color: "#00B2F7",//"#00A4FC",
      widthValue: 3,
      currentTab: 1,
      currentShape: 0,
      currentFont: 0,
      fontFamilies: [
        "Microsoft YaHei",
        "Pacifico",
        "Permanent Marker",
        "Vidaloka",
        "Dancing Script",
        "Oswald"
      ],
      colors: [
        "#ff8187",
        "#ff9100",
        "#b3d61d",
        "#6666f2",
        "#3ec765",
        "#cc7904",
        "#ff5d5a",
        "#00B2F7",
        "#ffd700",
        "#b362a6",
        "#000000",
        "#FFFFFF"
        // "#ff8187",
        // "#676EF9",
        // "#FF6B5B",
        // "#BB6EA9",
        // "#FFCE00",
        // "#D67A00",
        // "#B4C817",
        // "#FF9300",
        // "#35B363",
        // "#00A4FC",
        // "#010001",
        // "#FFFFFF"
      ],
      showColor: true,
      observer: null,
      currentOnColorFlag: false,
      recordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        width: "0",
        height: "0"
      },
      screenWidth: 0,
      screenHeight: 0
    };
  },
  created() {
    this.process()
  },
  mounted() {
    this.initCanvasData();
    const _this = this;
    // window.onbeforeunload = function(event) {
    //   event = event || window.event;
    //   event.returnValue = "您输入的内容尚未保存，确定离开此页面吗？";
    //   _this.draw.commitTextItem();
    // };
    window.onresize = () => {
      return (() => {
       this.setCanvasWH();
       this.draw.resetSize(this.canvasWidth,this.canvasHeight);
       //this.draw.resetSize(960,540);
      })();
    };
  },
  beforeDestroyed() {},
  destroyed() {
    this.process = null
  },
  methods: {
    mouseOnColorFlag(flag) {
      console.log("mouseOnColorFlag", flag);
      this.currentOnColorFlag = flag;
    },
    setCanvasWH(){
      let outer = document.getElementById("canvasouter");
      if (!outer) return
      let width =  outer.clientWidth || outer.offsetWidth || outer.style.width ||outer.scrollWidth;
      let height = outer.clientHeight || outer.offsetHeight ||outer.style.height ||  outer.scrollHeight;
       console.log(width, height);
       if(width*9/16<height){
        this.canvasWidth=width;
        outer.style.marginTop=(height-this.canvasWidth*9/16)/2+"px";
       }else{
        this.canvasWidth=height*16/9;
        outer.style.marginTop="0px"

       }

       this.canvasHeight=this.canvasWidth*9/16
       let canvasbox=document.getElementById("canvasbox");
       canvasbox.style.height=this.canvasHeight+"px";
       canvasbox.style.width = this.canvasWidth+"px";
    },
    loadData() {
      console.log(this.myPageAnswerList, 123)
      if (this.myPageAnswerList[0]) {
        this.one = this.myPageAnswerList[0]
        this.base64Str = this.one.content
      }
    },
    async process() { // 监控答案变化，0.8秒无操作提交答案
      let isChange = false
      if (this.processi > 8) {
        isChange = this.base64Str !== this.one.content
        this.processi = 0
        console.log('check draw change', isChange)
      }
      if (isChange) {
        await this.sendCanvas({...this.one}, this.base64Str)
        this.loadData()
        this.base64Str = this.one.content
      } else {
        this.processi++
      }
      setTimeout(this.process, 100)
    },
    async onDrawBack(dataStr) {
      this.base64Str = dataStr
    },
    onDrawTextBack(content) {
      console.log('saveTextDraw')
      this.sendDrawText(this.one, content)
    },
    initCanvasData() {
      this.loadData()
      this.setCanvasWH();
      let textCloseUrl= require('@/assets/picture/closebtn.svg')
      this.draw = new Draw("canvas","textCanvas", this.canvasWidth,this.canvasHeight,textCloseUrl);
      this.$nextTick(() => {
        this.draw.init(
          this.onDrawBack,
          this.onDrawTextBack,
          this.one.content,
          this.getQuestion.page,
          this.slide_id
        );
      });
    },
    doKeyDown(e) {
      // console.log(e);
    },
    changeColor(color) {
      this.colorVisible=false;
      this.color = color;
      this.draw.changeColor(color);
    },
    beforeunloadFn(e) {
      // ...
      // console.log("close page!!!");
      // this.draw.commitTextItem();
    },
    changeWidth(w, tabIndex) {
      this.lineVisible=false;
      this.pathVisible=false;
      this.markVisible=false;
      this.easreVisible=false;
      this.widthValue = w;
      this.draw.changeLineWitdh(w);
      if (tabIndex) {
        this.currentTab = tabIndex;
      }
      if (tabIndex == 1) {
        this.draw.changeDrawType(DrawTypeData.draw);
      }
      switch (tabIndex) {
        case 1:
          this.draw.changeDrawType(DrawTypeData.draw);
          break;
        case 2:
          this.draw.changeDrawType(DrawTypeData.line);
          break;
        case 3:
          this.draw.earse();
          break;
        case 4:
          this.draw.changeDrawType(DrawTypeData.text);
          break;
        case 5:
          this.draw.changeDrawType(DrawTypeData.marker);
          break;
      }
    },
    drawMark() {
      this.currentTab = 5;
      this.draw.changeDrawType(DrawTypeData.marker);
      this.draw.saveTextByButton();
    },
    drawPath() {
      this.currentTab = 1;
      this.draw.changeDrawType(DrawTypeData.draw);
      this.draw.saveTextByButton();

    },
    drawLine() {
      this.currentTab = 2;
      this.draw.changeDrawType(DrawTypeData.line);
      this.draw.saveTextByButton();
    },
    edit() {
      this.currentTab = 4;
      this.draw.changeDrawType(DrawTypeData.text);

    },
    earse() {
      this.draw.saveTextByButton();
      this.currentTab = 3;
      this.draw.earse();

    },
    undo() {
      this.draw.undo();

    },
    redo() {
      this.draw.redo();

    },
    clear() {
      this.draw.clearCanvas();
      this.draw.canRedo();

    },
    showDiy() {
      colorSelector.show(this.color, rgb => {
        // // console.log(d)
        const selectorColor = colorSelector.utils.rgb2txt(rgb);
        // console.log(selectorColor);
        this.changeColor(selectorColor);
      });
    },
    drawShape() {
      this.draw.saveTextByButton();
      if (this.currentShape == 0) {
        this.drawRect();
      } else if (this.currentShape == 1) {
        this.drawCircle();
      } else if (this.currentShape == 2) {
        this.drawPolygon();
      }
    },
    drawCircle() {
       this.shapeVisible=false;
      this.currentShape = 1;
      this.currentTab = 6;
      this.draw.changeDrawType(DrawTypeData.circle);
    },

    drawRect() {
      this.currentShape = 0;
      this.shapeVisible=false;
      this.currentTab = 6;
      this.draw.changeDrawType(DrawTypeData.rect);
    },
    drawPolygon() {
       this.shapeVisible=false;
      this.currentShape = 2;
      this.currentTab = 6;
      this.draw.changeDrawType(DrawTypeData.polygon);
    },
    changeTextFont(index) {
      this.fontVisible=false;
      this.currentFont = index;
      this.draw.setFontFamily(this.fontFamilies[index]);
      this.edit();
    },
    clickColor() {
      this.currentTab = 7;
    }
  }
};
</script>
<style scoped>
@import url("../../assets/css/color.css");
svg {
  opacity: 1;
}

@import url("https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Vidaloka&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Pacifico&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Oswald&display=swap");

</style>
<style scoped>
#diycolor {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  display: none;
  opacity: 0;
  transition: opacity 150ms linear;
}
#canvasouter {
  cursor: default;
  width: calc(100% - 60px);
  position: absolute;
  left: 60px;
  height: calc(100% - 2px);
  margin: auto;
}
#canvasbox{
  position: relative;
  margin:auto;
  overflow: hidden;

}
#canvas {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  position: absolute;
  left: 0;
  top: 0;

}
#textCanvas{
  border: #36425a 10px;

}
.color_flag {
  fill: rgb(171, 178, 218);
}

.cls-1-color-flag-gray {
  fill: rgb(171, 178, 218);
  /* stroke: #36425a; */
  stroke-linecap: round;
  stroke-linejoin: round;
  cursor: pointer;
}

/* .cls-1-color-flag-gray:hover {
  fill: white;
  stroke: #36425a;
  stroke-linecap: round;
  stroke-linejoin: round;
  cursor: pointer;
} */

.cls-1-color-flag-white {
  fill: white;
  stroke: #36425a;
  stroke-linecap: round;
  stroke-linejoin: round;
  cursor: pointer;
}

.color-1-svg {
  fill: rgb(171, 178, 218);
}
.color-2-svg {
  fill: rgb(171, 178, 218);
}
.color_flag:hover .color-1-svg {
  fill: red;
}
.cls-1-delete:hover .color-1-svg {
  fill: red;
}
.color_flag:hover .color-2-svg {
  fill: #36425a;
}

.cls-1-delete {
  fill: rgb(171, 178, 218);
  /* fill: rgb(0, 0, 0); */
}
.cls-1-delete:hover {
  fill: #36425a;
}

.text_area {
  display: flex;
  height: 50px;
  align-items: center;
  cursor: pointer;
}
.colorList {
  width: 120px;
  height: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  flex-wrap:  wrap;
}

.colors {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 5px;
  cursor: pointer;
}
.footer--contenter {
   width: 55px;
    height: auto;
    top: 50%;
    transform: translateY(-50%);
    left: 1px;
    flex-direction: row;
    position: fixed;
    z-index: 2;
    margin: 20px auto;
    display: flex;
    justify-content: center;
    align-items: center;

}
.canvasfooter {
  width: 100%;
    flex-direction: column;
    display: flex;
    background-color: #fff;
    align-items: center;
    justify-content: center;
    border: 1px solid rgb(244, 244, 244);
    border-radius: 6px;
    box-shadow: 0px 6px 5px 1px rgb(126 126 126);

}
.canvasfooter > div {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  cursor: pointer;
  line-height: 30px;
}
.red-pencial {
  border: 1px solid #999;
}
.eraser {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
#keyword-box {
  margin: 10px 0;
}
.canvasmodal {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  line-height: 20px;
}

.closemodal {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.dropdown-icon {
  width: 40px;
  height: 40px;
  display: flex;
  bottom: 10px;
  line-height: 40px;
  overflow: hidden;
}
.shape_area {
  display: flex;
  justify-content: space-around;
}
.shape_icon {
  cursor: pointer;
}

.do_btn {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.color_btn {
  height: 50px;
  width: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text-font {
  font-size: 20px;
}
.white-text-font{
  font-size: 20px;
  text-shadow: black 0px 0px 2px;
  -webkit-text-stroke: 1px black;
}

.st-ppt-outer {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  border: 1px solid #707070;
  box-shadow: 0px 10px 12px rgba(126, 126, 126, 0.16);
  display:flex;
  overflow: auto;
}
.ppt-out-line {


  box-sizing: border-box;
}
</style>
